import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { ApiError } from '@/lib/api/errors'
import { rescheduleReservation } from '@/lib/venue/reservationApi'
import type { ReservationDetailView, ReservationRescheduleInput } from '@/lib/venue/reservationTypes'

import { reservationDetailQueryKey } from './useVenueReservationDetail'

/**
 * 예약 변경 (#669 §1).
 *
 * 🚨 응답이 곧 최신 상세다 — 성공 시 상세 쿼리 캐시에 **직접 반영**하고 재조회하지 않는다(#669 §1-2,
 * `useUpdateCourt.ts`와 동일한 관례). 목록/캘린더/현황판 쿼리는 invalidate하지 않는다 — 전역
 * `staleTime: 0`으로 다음 방문·포커스 시 자연히 재조회된다(설계 §2 자율 결정 6).
 */
export function useRescheduleReservation(venueId: string, reservationId: number) {
  const queryClient = useQueryClient()

  return useMutation<ReservationDetailView, ApiError, ReservationRescheduleInput>({
    mutationFn: (input) => rescheduleReservation(venueId, reservationId, input),
    onSuccess: (data) => {
      queryClient.setQueryData(reservationDetailQueryKey(venueId, reservationId), data)
    },
  })
}
